<script>
import { Doughnut, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ['options'],
  computed: {
    // a computed getter
    optionsMerged: function() {
      // `this` points to the vm instance
      const defaultOptions = {
        noDataLabel: this.$t('charts.no_data'),
        datasetFill: false,
        responsive: true,
        maintainAspectRatio: true,
        animationSteps: 100,
        animationEasing: 'easeOutBounce',
        animateRotate: true,
        showScale: false,
        animateScale: false,
        legend: {
          display: false
        },
        cutoutPercentage: 70
      }
      return { ...defaultOptions, ...this.options }
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.optionsMerged)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/charts/DoughnutChart.vue